import React, { Component } from 'react';
import { connect } from "react-redux";
import Grid from '../../../components/grid';
import { deductionComparisonReport, payrollDetailAction } from '../../../store/actions';
import orderBy from "lodash/orderBy";
import './style.scss';
import Select from 'react-select';
import { format, subDays } from 'date-fns';
import { noop } from 'lodash';
class DeductionComparisonView extends Component {


    state = {
        loading: false,
        firstSelectOptions: [],
        selectedFirstPayroll: {},
        secondSelectOptions: [],
        selectedSecondPayroll: {},
        selectedStartWeek: "",
        selectedEndWeek: "",
        firstPayrollId: "",
        secondPayrollId: "",
        rowData: null,
        columnDefs: [
            {
                headerName: "Employee Id",
                field: "employeeId"
            }, {
                headerName: "Employee Last Name",
                field: "empLastName",
            }, {
                headerName: "Employee First Name",
                field: "empFirstName"
            },
        ]
    };

    getLastPayrolls = async () => {
        await this.props.payrollDetailAction(this.props.UserReducer.company, {
            includeUnfinalized: true,
            payrollType: "Regular",
            addNumberDays: 14
        });
    };

    async componentDidMount() {
        this.setState({
            loading: true,
        });
        await this.getLastPayrolls();
        this.setSelectOptions(this.props.PayrollReducer, this.submit);
        //await this.submit();
    };

    submit = async () => {
        this.setState({ loading: true, rowData: null })
        await this.props.deductionComparisonReport({
            company: this.props.UserReducer.company,
            firstPayrollId: this.state.firstPayrollId,
            secondPayrollId: this.state.secondPayrollId
        });
        this.setColumns();
        this.setState({ rowData: this.props.DEDUCTION_COMPARISON_REPORT || [], loading: false });
    };

    setColumns = () => {
        let { firstPayDate, secondPayDate } = this.state;
        firstPayDate = format(new Date(firstPayDate), "MM/dd/yyyy");
        secondPayDate = format(new Date(secondPayDate), "MM/dd/yyyy");
        let dynamicColumns = [
            {
                headerName: `${firstPayDate}`,
                field: `${firstPayDate}`
            }, {
                headerName: `${secondPayDate}`,
                field: `${secondPayDate}`
            },
            {
                headerName: 'E/D/T Name',
                field: "EDTName"
            },
            {
                headerName: "Difference",
                field: 'diff'
            },
        ];
        this.state.columnDefs = [...this.state.columnDefs, ...dynamicColumns];
    };

    handleStartWeekChanges = selected => {
        this.setState({
            selectedStartWeek: selected.label,
            firstPayrollId: selected.value,
            selectedFirstPayroll: selected,
            firstPayDate: selected.payDate
        });
        this.setSecondOptions(selected);
    };

    handlePreviousWeekChanges = selected => {
        let secondPayrollId = selected.value
        this.setState({
            selectedEndWeek: selected.label,
            secondPayrollId,
            selectedSecondPayroll: selected
        });
    };

    setSelectOptions = (payrollsList, callback) => {

        let firstSelectOptions = orderBy(payrollsList.filter(prl => {
            return (prl.payrollName.startsWith("Bi-Weekly") || prl.payrollName.startsWith("Admin Bi-Weekly")) && prl.payPeriodEnd;
        }).map(prl => {
            let { payrollName, payrollSystemId, payDate } = prl;
            let datePayDate = new Date(payDate);
            let utcPayDate = new Date(datePayDate.getUTCFullYear(), datePayDate.getUTCMonth(), datePayDate.getUTCDate());
            return {
                label: payrollName,
                value: payrollSystemId,
                payDate: utcPayDate.toLocaleDateString()
            }
        }),
            elem => Date.parse(elem.payDate), "desc")
        let selectedFirstPayroll = firstSelectOptions[0] || {};
        let { label, value, payDate } = selectedFirstPayroll;

        this.setState({
            firstSelectOptions,
            selectedFirstPayroll,
            firstPayrollId: value,
            selectedStartWeek: label,
            firstPayDate: payDate
        }, () => {
            this.setSecondOptions(selectedFirstPayroll, callback);
        });

    }

    setSecondOptions = (selectedFirstPayroll, callback) => {
        let firstIndex = this.state.firstSelectOptions.findIndex(op => op.value === selectedFirstPayroll.value);
        let secondSelectOptions = this.state.firstSelectOptions.map((el, idx) => ({ ...el, isDisabled: idx <= firstIndex }));
        let selectedSecondPayroll = {}, selectedEndWeek, secondPayrollId, secondPayDate;
        if (firstIndex < (secondSelectOptions.length - 1)) {
            selectedSecondPayroll = secondSelectOptions[firstIndex + 1];
            let { label, value, payDate } = selectedSecondPayroll;
            selectedEndWeek = label;
            secondPayrollId = value;
            secondPayDate = payDate
        };
        this.setState({
            secondSelectOptions,
            selectedSecondPayroll,
            selectedEndWeek,
            secondPayrollId,
            secondPayDate
        }, callback || noop);
    };

    render() {

        const { loading, firstSelectOptions, secondSelectOptions, selectedFirstPayroll, selectedSecondPayroll } = this.state;

        return (
            <>
                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between table-header patient_hours">
                        <div className="filter-field d-flex align-items-center justify-content-between">
                            <label>Current Week</label>
                            <Select className="reactSelect"
                                onChange={(e) => this.handleStartWeekChanges(e)}
                                value={selectedFirstPayroll}
                                options={firstSelectOptions}
                            >

                            </Select>
                            <div className="filter-field d-flex">
                                <label>Compare to week</label>
                                <Select className="reactSelect"
                                    onChange={(e) => this.handlePreviousWeekChanges(e)}
                                    options={secondSelectOptions}
                                    value={selectedSecondPayroll}
                                >
                                </Select>
                            </div>
                        </div>
                        <button className="mla fs12 primary mini" onClick={this.submit} disabled={loading}>
                            {loading ? <span>Loading data </span> : <span>Run</span>}
                        </button>
                    </div>
                    <Grid
                        columnDefs={this.state.columnDefs}
                        rowData={this.state.rowData}
                        height='600px'
                    >
                    </Grid>

                </div>
            </>
        )
    }
}
const mapStateToProps = ({ UserReducer, PayrollComparisonsReducer, PayrollReducer }) => {
    const { DEDUCTION_COMPARISON_REPORT } = PayrollComparisonsReducer;
    return { UserReducer, DEDUCTION_COMPARISON_REPORT, PayrollReducer }
};

export default connect(mapStateToProps, {
    deductionComparisonReport,
    payrollDetailAction
})(DeductionComparisonView);
